import { siteInfo } from '@/mocks/anime';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  let schema: Record<string, unknown>;

  switch (type) {
    case 'Organization':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        logo: siteInfo.logo,
        ...data,
      };
      break;
    case 'WebSite':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteInfo.url}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
        ...data,
      };
      break;
    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: siteInfo.name,
        description: siteInfo.description,
        url: siteInfo.url,
        ...data,
      };
      break;
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        publisher: {
          '@type': 'Organization',
          name: siteInfo.name,
          logo: { '@type': 'ImageObject', url: siteInfo.logo },
        },
        ...data,
      };
      break;
    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (data.mainEntity as Array<Record<string, unknown>>) || [],
      };
      break;
    default:
      schema = { '@context': 'https://schema.org', ...data };
  }

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}